(function (angular) {
    'use strict';
    angular
        .module('app.purchase')
        .controller('app.purchase.signInController', [
            '$scope',
            '$http',
            '$uibModalInstance',
            'app.purchase.purchaseFlowService',
            '$interval',
            signInController
        ]);
   
    function signInController($scope, $http, $uibModalInstance, purchaseFlowService, $interval) {
        var vm = this;
        vm.siteContent = siteContent;
        vm.start = start;
        vm.done = done;
        vm.dismiss = dismiss;
        vm.signInOptionClick = signInOptionClick;
        vm.checkIfUserIsActivated = checkIfUserIsActivated;
        vm.generateOTP = generateOTP;
        vm.authenticateOTP = authenticateOTP;
        vm.enableSendButton = enableSendButton;
        vm.signInMemberPortal = signInMemberPortal;
        vm.otpChanged = otpChanged;
        vm.userInfo = purchaseFlowService.getUserInfo();
        vm.signInOption = "";
        vm.memberPortalSignIn = environment.memberPortalUrl;
        vm.rememberLogin = true;
        vm.showLogin = true;
        vm.forgotPassword = false;
        vm.emailSent = false;
        vm.isAuthenticated = true;
        vm.timer = 300;  //seconds
        vm.isTimerOn = false;
        vm.email_otp = '';
        vm.sms_otp = '';
        vm.disableConfirm = true;
        vm.showUserNotActivated = false;
        vm.checkIfUserIsActivated();
        vm.signInOptionClick();
        
        function checkIfUserIsActivated() {
            if(!vm.userInfo.userName) {
                vm.showUserNotActivated = true;
                purchaseFlowService.sendActivationEmail({userId: vm.userInfo.id, benefitPlanId: null});
            }
        }

        function start() {            
            vm.timer = 300;  //seconds
            vm.isTimerOn = true;
            var promise = $interval(function(){
                vm.timer--;
                if(vm.timer == 0) {
                    $interval.cancel(promise);
                    vm.isTimerOn = false;
                }
            },1000);
        }

        //Close the modal
        function done() {
            $uibModalInstance.close(true);
        }

        function dismiss() {
            $uibModalInstance.close(false);
        }

        function signInOptionClick() {
            vm.email_otp = '';
            vm.sms_otp = '';
            vm.smsOtpReceived = false;
            vm.emailOtpReceived = false;
            vm.sendSmsOtpBtnText = "Send";
            vm.sendEmailOtpBtnText = "Send";
            vm.isAuthenticated = true;
            vm.isTimerOn = false;
        }

        function enableSendButton() {
            if(vm.smsOtpReceived || vm.emailOtpReceived) {
                vm.sendSmsOtpBtnText = "Resend";
                vm.sendEmailOtpBtnText = "Resend";
            }
            else {
                vm.sendSmsOtpBtnText = "Send";
                vm.sendEmailOtpBtnText = "Send";
            }
            vm.smsOtpReceived = false;
            vm.emailOtpReceived = false;
            vm.isTimerOn = false;
        }

        function generateOTP() {  
            var sendSms = true;
            vm.isAuthenticated = true;
            if(vm.signInOption === 'email_otp') {
                sendSms = false;
            }
            purchaseFlowService
            .generateOTP({userName: vm.userInfo.emailAddress, sendSms: sendSms})
            .then(function (){
                vm.start();
                if(sendSms){
                    vm.smsOtpReceived = true;
                    vm.emailOtpReceived = false;
                    vm.sendSmsOtpBtnText = "Resend";
                }
                else {
                    vm.smsOtpReceived = false;
                    vm.emailOtpReceived = true;
                    vm.sendEmailOtpBtnText = "Resend";
                }
            })
            .finally(function () {
                ui.unblock();                
            });
        }

        function authenticateOTP() {
            vm.isAuthenticated = true;
            var otp ='';
            if(vm.signInOption === 'email_otp') {
                otp = vm.email_otp;
            } else if(vm.signInOption === 'sms_otp') {
                otp = vm.sms_otp;
            }
            purchaseFlowService
            .authenticateOTP({userName: vm.userInfo.emailAddress, oneTimePassword: otp, rememberLogin: vm.rememberLogin})
            .then(function (results) {
                var userName = purchaseFlowService.getUserName();
                if (userName != null && userName != '') {
                    vm.isAuthenticated = true;
                    var url = environment.memberPortalUrl.replace('#/home?brand=','?otp_token=' + results.otpToken);
                    window.location.replace(url);
                    vm.dismiss();
                }
                else {
                    vm.isAuthenticated = false;
                    vm.enableSendButton();
                }
            })
            .finally(function () {
                var userName = purchaseFlowService.getUserName();   
                if (userName == null || userName === '') {
                    vm.isAuthenticated = false;
                    vm.enableSendButton();
                }
            });
        }

        function signInMemberPortal() {
            window.location = vm.memberPortalSignIn;
        }

        function otpChanged() {
            if(vm.email_otp === "" && vm.sms_otp === "") {
                vm.disableConfirm = true;
            }
            else {
                vm.disableConfirm = false;
            }
        }
    }

})(angular);
